import { HttpClient, HttpHeaders } from '@angular/common/http';
import { catchError } from 'rxjs/operators';
import { ErrorObservable } from "rxjs/observable/ErrorObservable";
var TowerService = /** @class */ (function () {
    function TowerService(http) {
        this.http = http;
    }
    TowerService.prototype.obtainToken = function (idToken) {
        var request = {
            idToken: idToken
        };
        return this.http.post('/api/token', request).pipe(catchError(this.handleError));
    };
    TowerService.prototype.setAccessToken = function (token) {
        this.accessToken = token;
    };
    TowerService.prototype.getDebranchementUrl = function (id) {
        var url = '/api/debranchement/' + id;
        return this.http.get(url, this.getRequestOptions()).pipe(catchError(this.handleError));
    };
    TowerService.prototype.rechercherLogs = function (criteres) {
        return this.http.post('/api/logs', criteres, this.getRequestOptions()).pipe(catchError(this.handleError));
    };
    TowerService.prototype.recupererLogitem = function (id) {
        return this.http.get('/api/logs/' + id, this.getRequestOptions()).pipe(catchError(this.handleError));
    };
    TowerService.prototype.listerQueues = function () {
        return this.http.get('/api/queues', this.getRequestOptions()).pipe(catchError(this.handleError));
    };
    TowerService.prototype.lireQueue = function (queue) {
        return this.http.get('/api/queues/' + queue, this.getRequestOptions()).pipe(catchError(this.handleError));
    };
    TowerService.prototype.injecterMessage = function (queue, message) {
        return this.http.post('/api/queues/' + queue + '/move', message, this.getRequestOptions()).pipe(catchError(this.handleError));
    };
    TowerService.prototype.supprimerMessage = function (queue, message) {
        return this.http.post('/api/queues/' + queue + "/delete", message, this.getRequestOptions()).pipe(catchError(this.handleError));
    };
    TowerService.prototype.handleError = function (error) {
        if (error.error instanceof ErrorEvent) {
            // A client-side or network error occurred. Handle it accordingly.
            console.error('An error occurred:', error.error.message);
        }
        else {
            // The backend returned an unsuccessful response code.
            // The response body may contain clues as to what went wrong,
            console.error("Backend returned code " + error.status + ", body was: " + error.error);
            if (error.status === 412 && error.error.message != null && error.error.message != undefined) {
                return new ErrorObservable(error.error.message);
            }
        }
        // return an ErrorObservable with a user-facing error message
        return new ErrorObservable('Une erreur s\'est produite, veuillez ré-essayer ultérieurement.');
    };
    TowerService.prototype.getRequestOptions = function () {
        var headers = new HttpHeaders({ 'Access-Token': this.accessToken });
        return { headers: headers };
    };
    return TowerService;
}());
export { TowerService };



// WEBPACK FOOTER //
// ./src/app/api/service/tower.service.ts.pre-build-optimizer.js